export function performClientLogout(navigate) {

  localStorage.removeItem('authToken');

  if (typeof navigate === 'function') {
    navigate('/login', { replace: true });
  } else {
    window.location.href = '/login';
  }
}
